export default async function unlockApp({ context, nextMiddleware }){
  await context.store.dispatch('unlockApp')
	return nextMiddleware()
}
